module.exports = __webpack_public_path__ + "static/media/type.37dea35d.svg";